/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import {
  Grid, Tab, Tabs, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { usePaymentForm } from './usePaymentForm';
import { DirectDebitTabPanel } from './Component/DirectDebitTabPanel';
import { CreditCardTabPanel } from './Component/CreditCardTabPanel';

/**
 * PaymentForm Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function PaymentForm(props) {
  const { t } = useTranslation();
  const { tab, handleTabChange } = usePaymentForm();
  const { validateField } = useFormikContext();
  const {
    formField: { accountOwner, iban, paymentTerms },
  } = props;

  /**
     * Render Payment Tabs
     * @returns {React.JSX.Element}
     */
  const renderPaymentTabs = () => (
    <>
      <Tabs value={tab} onChange={(event, newValue) => handleTabChange(newValue)}>
        <Tab key={t('paymentDirectDebit')} label={t('paymentDirectDebit')} />
        <Tab key={t('paymentCreditCard')} label={t('paymentCreditCard')} />
      </Tabs>
      <DirectDebitTabPanel
        value={tab}
        index={0}
        accountOwner={accountOwner}
        iban={iban}
        validateField={validateField}
        paymentTerms={paymentTerms}
      />
      <CreditCardTabPanel value={tab} index={1} />
    </>
  );

  return (
    <>
      <Typography mt={4} textAlign="center" variant="h2">
        4.
        {' '}
        {t('stepFourHeader')}
      </Typography>
      <Grid container justifyContent="center" mt={4} gap={2}>
        <Grid
          p={{
            xs: 2,
            sm: 4,
          }}
          item
          border="2px solid #49ad33"
          sx={{ backgroundColor: '#222' }}
          xs={12}
          md={8}
        >
          {renderPaymentTabs()}
        </Grid>
      </Grid>
    </>
  );
}

PaymentForm.propTypes = {
  formField: PropTypes.object.isRequired,
};
